type TParams = {
  width?: number | null;
  length?: number | null;
  areaUser?: number | null;
};

export const getAreaUser = (inputParams: TParams): number => {
  if (inputParams.areaUser) {
    return inputParams.areaUser;
  }
  const { length, width } = inputParams;
  if (length && width) {
    return length * width;
  }
  return 0;
};
